
<div class="sale-send-email-sms-popup">
  <app-notification-template #primaryRef [labelSubmitButton]="buttonLabel" [allowGrouping]="true" [allowDisableSubmit]="true" [inputRecipients]="recipients"
    [inputMessageTemplate]="messageTemplate" (onSubmit)="onSubmit()" (onCancel)="onCancel()"></app-notification-template>
</div>

